import { useContext } from 'react';

import { ContextoAuth } from './contexto';
import { type ContextoAuth as FormaDoContexto } from './tipos';

/**
 * Acesso ao estado de autenticacao.
 *
 * Fora do provedor, lanca. E defeito de montagem, nao situacao de usuario: tela
 * que precisa saber quem esta autenticado tem de estar dentro do provedor.
 */
export function useAuth(): FormaDoContexto {
  const contexto = useContext(ContextoAuth);

  if (!contexto) {
    throw new Error('useAuth foi chamado fora do ProvedorAuth.');
  }

  return contexto;
}
